export default {
  text: {
    id: 'us_payment_advertisement_text',
    defaultMessage: 'Pay over time with',
  },
  tooltipIconAriaLabel: {
    id: 'us_payment_advertisement_tooltip_icon_aria_label',
    defaultMessage: 'More information about pay over time options',
  },
  tooltipContent: {
    id: 'us_payment_advertisement_tooltip_content',
    defaultMessage:
      'Pay in installments due bi-weekly or monthly with Affirm, Klarna, or PayPal. Find full details at checkout.',
  },
}
